import { fetchWithErrorHandling } from './apiUtils';
import { ReorderRequestPayload } from '../types';

export async function submitReorderRequest(payload: ReorderRequestPayload): Promise<void> {
  await fetchWithErrorHandling<{ message: string }>('/api/v2/reorder-request', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(payload),
  });
}
